
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/third-cond-explanation';
const mainimage = '/Images/thirdcond1.webp';

const sections = [
  { label: "Exercises", description: "Do this exercise to practice your grammar.", type: "quiz", subtype: "thirdcond" },
];

const ThirdConditional = () => (
  <GrammarPageLayout
    level="B2"
    title="Third Conditional"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Third Conditional Exercises"
    seoDescription="Master past unreal situations: if + past perfect, would have + past participle. C1 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="C1"
  />
);

export default ThirdConditional;

